
import * as Yup from 'yup';

export const elementosDeProteccionValidation = (elementosDeProteccionSeleccionados) => (
  Yup.object().shape({
    idElementoDeProteccion: Yup.number().required("Campo Obligatorio").nullable().test({
      name: "sinElementosRepetidos",
      message: "El elemento ya está asociado a este puesto.",
      test: function (value) {
        if (!(elementosDeProteccionSeleccionados.some((e) => e.idElementoDeProteccion === value))) {
          return true;
        }
        return false;
      },
    })
  })
);

export const medidasPreventivasValidation = (medidasPreventivasSeleccionadas) => (
  Yup.object().shape({
    idMedidaPreventiva: Yup.number().required("Campo Obligatorio").nullable().test({
      name: "sinMedidasRepetidas",
      message: "La medida ya está asociada a este puesto.",
      test: function (value) {
        if (!(medidasPreventivasSeleccionadas.some((e) => e.idMedidaPreventiva === value))) {
          return true;
        }
        return false;
      },
    })
  })
);

export const puestosAsociadosValidation = (puestos = [], editingIndex = null) => Yup.object().shape({
  sustanciasSeleccionadas: Yup.array()
    .min(1, "Debe seleccionar al menos una sustancia")
    .test({
      name: "sustanciasNoRepetidasPorPuesto",
      message: "El puesto ya tiene alguna de esas sustancias asociadas.",
      test: function (value) {
        const puestoId = this.parent?.puesto;
        if (!puestoId || !Array.isArray(value) || value.length === 0) return true;
        const selected = new Set(value.map((id) => Number(id)));
        return !puestos.some((p, index) => {
          if (index === editingIndex || Number(p.puesto) !== Number(puestoId)) return false;
          const sustanciasExistentes = (p.sustancias || []).map((id) => Number(id));
          return sustanciasExistentes.some((id) => selected.has(id));
        });
      },
    }),
  puesto: Yup.number()
    .required("El puesto es obligatorio")
    .nullable(),
  nombrePuesto: Yup.string().required("El puesto es obligatorio"),
  descripcionActividades: Yup.string().required(
    "Descripción de actividades es obligatoria"
  ).max(300, "Máximo 300 caracteres"),
  descripcionEstudios: Yup.string().required(
    "Descripción de estudios es obligatoria"
  ).max(150, "Máximo 150 caracteres"),
});